import React from 'react';
import { Large } from './Variants/Large/Large';
import { Small } from './Variants/Small/Small';

export const ButtonLoaderVariants = {
  LARGE: 'Large',
  SMALL: 'Small',
} as const;

type ButtonLoaderProps =
  | { variant: typeof ButtonLoaderVariants.LARGE }
  | { variant: typeof ButtonLoaderVariants.SMALL };

export const ButtonLoader: React.FC<ButtonLoaderProps> = React.memo((props) => {
  switch (props.variant) {
    case ButtonLoaderVariants.LARGE:
      return <Large />;
    case ButtonLoaderVariants.SMALL:
      return <Small />;
  }
});

ButtonLoader.displayName = 'ButtonLoader';
